/* eslint-disable react/sort-comp */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import requireAuth from '../../components/hocs/requireAuth';
import requireOnboarding from '../../components/hocs/requireOnboarding';
import * as actions from '../../actions/profile-actions';
import { fetchPaidHitClub } from '../../actions';
import ProfileEditForm from '../../components/ProfileEditForm';
import { months, daysPerMonth, daysOfWeek } from '../../utils/calendar';
import { isEmpty } from '../../utils/validation';

import styles from './profileEdit.scss';

class ProfileEditPage extends Component {
    constructor(props) {
        super(props);

        let startMonth = null;
        if (props.auth.user && props.auth.user.month) {
            startMonth = props.auth.user.month;
        }
        this.state = {
            submitting: false,
            geocodeResults: null,
            location: '',
            nationalityGeocodeResults: null,
            nationalityLocation: '',
            days: startMonth ? daysPerMonth[startMonth - 1] : daysPerMonth[0],
            months,
            availableRegionOptions: [],
            isSelectRegionDisabled: false,
            availableRegionsLoaded: false,
            isRegionLocked: false,
            isLocationChosenFromDropdown: true,
            isNationalityChosenFromDropdown: true,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
        this.handleNationalityChange = this.handleNationalityChange.bind(this);
        this.handleNationalitySelect = this.handleNationalitySelect.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { user } = this.props.auth;
        const canEditProfile = user && user.claimedPlayer && user.claimedPlayer.playerId && (user.claimedPlayer.playerId.toString() === this.props.match.params.playerId);
        if (!canEditProfile) {
            this.props.history.push('/');
        }
    }

    componentDidMount() {
        this.props.setPlayerId(this.props.match.params.playerId);
    }

    componentDidUpdate() {
        const { isProfileLoaded, data } = this.props.profile;
        this.setAvailableRegionsOptionsFromProfile(isProfileLoaded, data);
    }

    setAvailableRegionsOptionsFromProfile(isProfileLoaded, data) {
        if (isProfileLoaded && !this.state.availableRegionsLoaded) {
            let availableRegionsOptions = [];
            if (data.playerProfileInformation?.availableRegions != null) {
                availableRegionsOptions = data.playerProfileInformation?.availableRegions.map((region) => {
                    return { value: region.id, label: region.name };
                });
            }

            const isRegionLocked = data.playerProfileInformation?.isRegionLocked;
            this.setState({
                availableRegionOptions: availableRegionsOptions,
                availableRegionsLoaded: true,
                isSelectRegionDisabled: isRegionLocked || availableRegionsOptions.length === 0,
                isRegionLocked,
            });
        }
    }

    async handleSubmit(values) {
        values.values.favoritePlayers = values.values.favoritePlayers.map(p => p.id);
        values.values.month = (values.values.month ? (Math.max(months.indexOf(values.values.month), 0) + 1) : null);

        // format paidHitAvailability
        daysOfWeek.forEach((dayOfWeek, i) => {
            if (!isEmpty(values.values?.paidHitAvailability[i]?.availability?.trim())) {
                values.values.paidHitAvailability[i].day = dayOfWeek;
                values.values.paidHitAvailability[i].isAvailable = true;
            } else {
                values.values.paidHitAvailability[i] = {
                    day: dayOfWeek,
                    isAvailable: false,
                };
            }
        });

        this.setState({ submitting: true });
        const profileSaved = await this.props.savePlayerProfile(values.values);
        this.setState({ submitting: false });
        if (profileSaved) {
            location.href = `/profiles/${this.props.profile.playerId}`;
        }
    }

    handleLocationChange(location) {
        this.setState({
            location,
            geocodeResults: null,
            isLocationChosenFromDropdown: false,
        });
    }

    handleLocationSelect(location) {
        this.setState({
            location,
            isLocationChosenFromDropdown: true,
        });
        if (!this.state.isRegionLocked) {
            this.setState({ isSelectRegionDisabled: true }, () => {
                this.getCodeByAddressHandler(location);
            });
        }
    }

    getCodeByAddressHandler(location) {
        geocodeByAddress(location)
            .then(vals => {
                getLatLng(vals[0]);
                this.loadAvailableRegions(vals);
            });
        geocodeByAddress(location)
            .then(results => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                this.setState({
                    geocodeResults: { lat, lng },
                });
            })
            .catch(() => {
                this.setState({
                    geocodeResults: null, // TODO: handle error properly
                });
            });
    }

    getCountryAndStateFromLocation(results) {
        const countryStateResult = { stateAbbr: null, countryCode: null };
        for (let i = 0; i < results[0].address_components.length; i += 1) {
            if (results[0].address_components[i].types.includes('administrative_area_level_1')) {
                countryStateResult.stateAbbr = results[0].address_components[i].short_name;
            }
            if (results[0].address_components[i].types.includes('country')) {
                countryStateResult.countryCode = results[0].address_components[i].short_name;
            }
        }
        return countryStateResult;
    }

    loadAvailableRegions(results) {
        this.setState({ availableRegionOptions: [], isSelectRegionDisabled: true }, () => {
            const { stateAbbr, countryCode } = this.getCountryAndStateFromLocation(results);
            // TODO: use isoCountryCode2
            if (countryCode === 'US' || countryCode === 'PR') {
                const regionsResponse = this.getAvailableRegionsByStateCountry(stateAbbr, countryCode);
                regionsResponse.then((response) => {
                    if (response && response.availableRegions) {
                        const availableRegionsOptions = response.availableRegions.map((region) => {
                            return { value: region.id, label: region.name };
                        });
                        this.setState({
                            availableRegionOptions: availableRegionsOptions,
                            isSelectRegionDisabled: !availableRegionsOptions.length,
                        });
                    }
                });
            }
        });
    }

    async getAvailableRegionsByStateCountry(stateAbbr, countryCode) {
        const result = await this.props.getAvailableRegions(stateAbbr, countryCode);
        return result;
    }

    handleNationalityChange(location) {
        this.setState({
            nationalityLocation: location,
            nationalityGeocodeResults: null,
            isNationalityChosenFromDropdown: false,
        });
    }

    handleNationalitySelect(location) {
        this.setState({
            nationalityLocation: location,
            isNationalityChosenFromDropdown: true,
        });

        geocodeByAddress(location)
            .then(results => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                console.log('Geocode Success', { lat, lng });
                this.setState({
                    nationalityGeocodeResults: { lat, lng },
                });
            })
            .catch(error => {
                console.log('Geocode Error', error);
                this.setState({
                    nationalityGeocodeResults: null, // TODO: handle error properly
                });
            });
    }

    handleMonthChange(val) {
        const monthVal = months.indexOf(val);
        this.setState({
            days: val ? daysPerMonth[monthVal] : daysPerMonth[0],
        });
    }

    render() {
        const { isProfileLoaded, data } = this.props.profile;
        const locationInputProps = {
            // value: this.state.location,
            placeholder: 'Location (zip or city)',
            name: 'location',
        };
        if (isProfileLoaded) {
            if (this.state.location === '' && data.residence !== this.state.location) {
                this.setState({ location: data.residence });
            }
            if (this.state.nationalityLocation === '' && data.locationNationality !== this.state.nationalityLocation) {
                this.setState({ nationalityLocation: data.locationNationality });
            }
        }
        return (
            <div className={`${styles.section}`}>
                <div className={`container h2 bg-transparent`}>
                    <h2 className="text-center" data-testid="profile-edit.page.title">Edit Profile</h2>
                </div>
                {isProfileLoaded && (
                    <ProfileEditForm
                        coreUI={this.props.coreUI}
                        profileData={data}
                        handleSubmit={this.handleSubmit}
                        submitting={this.state.submitting}
                        availableRegionValues={this.state.availableRegionValues}
                        locationInputProps={locationInputProps}
                        handleLocationChange={this.handleLocationChange}
                        handleLocationSelect={this.handleLocationSelect}
                        handleNationalityChange={this.handleNationalityChange}
                        handleNationalitySelect={this.handleNationalitySelect}
                        geocodeResults={this.state.geocodeResults}
                        nationalityGeocodeResults={this.state.nationalityGeocodeResults}
                        days={this.state.days}
                        months={this.state.months}
                        handleMonthChange={this.handleMonthChange}
                        availableRegionOptions={this.state.availableRegionOptions}
                        isSelectRegionDisabled={this.state.isSelectRegionDisabled}
                        auth={this.props.auth}
                        fetchPaidHitClub={this.props.fetchPaidHitClub}
                        isLocationChosenFromDropdown={this.state.isLocationChosenFromDropdown}
                        isNationalityChosenFromDropdown={this.state.isNationalityChosenFromDropdown}
                    />
                )}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPlayerId: (playerId) => {
            dispatch(actions.setPlayerId(playerId, false));
        },
        savePlayerProfile: (profileValues) => dispatch(actions.savePlayerProfile(profileValues)),
        getAvailableRegions: (stateabbr, countryCode) => dispatch(actions.getAvailableRegions(stateabbr, countryCode)),
        fetchPaidHitClub: (clubId) => dispatch(fetchPaidHitClub(clubId)),
    };
}

function mapStateToProps({ auth, profile, header, coreUI }) {
    return { auth, profile, header, coreUI };
}

export default requireAuth(requireOnboarding(connect(mapStateToProps, mapDispatchToProps)(ProfileEditPage)));
